import React from 'react';
import { Card, Row, Col, Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import { TOOTH_CONDITIONS } from './constants/teethData';
import './DentalChartLegend.css';

/**
 * DentalChartLegend Component
 * Displays color codes and symbols for different tooth conditions
 */
const DentalChartLegend = ({ compact = false, showTitle = true }) => {
    const { t } = useTranslation(['tooth']);

    const conditions = Object.entries(TOOTH_CONDITIONS);

    if (compact) {
        return (
            <div className="dental-legend-compact">
                {conditions.map(([key, data]) => (
                    <div key={key} className="legend-item-compact">
                        <span
                            className="legend-color-box-compact"
                            style={{
                                backgroundColor: data.color,
                                borderColor: data.borderColor
                            }}
                        >
                            {data.icon}
                        </span>
                        <span className="legend-label-compact">
                            {t(data.label)}
                        </span>
                    </div>
                ))}
            </div>
        );
    }

    return (
        <Card
            title={showTitle ? t('tooth:conditionLegend') : null}
            size="small"
            className="dental-chart-legend"
        >
            <Row gutter={[16, 12]}>
                {conditions.map(([key, data]) => (
                    <Col xs={12} sm={12} md={8} lg={6} xl={6} key={key}>
                        <div className="legend-item">
                            <div
                                className="legend-color-box"
                                style={{
                                    backgroundColor: data.color,
                                    borderColor: data.borderColor
                                }}
                            >
                                <span className="legend-icon">{data.icon}</span>
                            </div>
                            <div className="legend-text">
                                <div className="legend-label">
                                    {t(data.label)}
                                </div>
                                <div className="legend-color-code">
                                    {data.borderColor}
                                </div>
                            </div>
                        </div>
                    </Col>
                ))}
            </Row>

            <div className="legend-note">
                <small>
                    {t('tooth:legendNote', 'Click on any tooth to view detailed history and information')}
                </small>
            </div>
        </Card>
    );
};

export default DentalChartLegend;
